import React from 'react';
import { Row, Col } from 'antd';


class BottomBanner extends React.Component {
    constructor(props) {
        //父组件传入参数
        super(props);    
        //当前组件状态
        this.state = {    
                
        }
    };

    render(){
		return(
			<Row className="bottom-banner" style={this.props.bgcolor} justify='space-around'>
				<Col span={4}>
					<div className='bottom-banner-itemtext-cn'>关于魔席</div>
					<div className='bottom-banner-itemtext-en'>About MX</div>
					<div className='botton-banner-item'><a className='botton-banner-item-a' href='/forest/'>魔席平台</a></div>
					<div className='botton-banner-item'><a className='botton-banner-item-a' href='https://app.moxidata.cn/moximerchants/moxiindex/'>魔席招商</a></div>
					<div className='botton-banner-item'><a className='botton-banner-item-a' href='/forest/'>文旅森林</a></div>
					<div className='botton-banner-item'><a className='botton-banner-item-a' href='https://app.moxidata.cn/college/'>文旅学院</a></div>
				</Col>
				<Col span={4}>
					<div className='bottom-banner-itemtext-cn'>网站服务</div>
					<div className='bottom-banner-itemtext-en'>Hyperlinks</div>
					<div className='botton-banner-item'><a className='botton-banner-item-a' href='/forest/artkey'>文章敲敲乐</a></div>
					<div className='botton-banner-item'><a className='botton-banner-item-a' href='https://app.moxidata.cn/moximodel/'>聊聊数语</a></div>
					<div className='botton-banner-item'><a className='botton-banner-item-a' href='/forest/corpus'>文旅词涟</a></div>
					<div className='botton-banner-item'><a className='botton-banner-item-a' href='/forest/policy'>文旅政确</a></div>
					<div className='botton-banner-item'><a className='botton-banner-item-a' href='https://app.moxidata.cn/newcharts/pie/'>可视数据</a></div>
					<div className='botton-banner-item'><a className='botton-banner-item-a' href='https://app.moxidata.cn/macroscopic/'>宏观数据</a></div>
					<div className='botton-banner-item'><a className='botton-banner-item-a' href='https://app.moxidata.cn/scenic/'>景区流量</a></div>
					<div className='botton-banner-item'><a className='botton-banner-item-a' href='/forest/hotText'>文旅热文</a></div>
					<div className='botton-banner-item'><a className='botton-banner-item-a' href='https://app.moxidata.cn/newcharts/citiesmap/'>3D看地</a></div>
					<div className='botton-banner-item'><a className='botton-banner-item-a' href='https://app.moxidata.cn/moximerchants/moxiindex/'>招商对接</a></div>
				</Col>
				<Col span={4}>
					<div className='bottom-banner-itemtext-cn'>手机端产品</div>
					<div className='bottom-banner-itemtext-en2'>Product Matrix</div>
					<div className='bottom-banner-xcx'>
						<div><span className='xcx-text'>小程序</span> TRUE榜样</div>
						<img src='/forest/image/xcx_true.jpg' alt="" className='xcx-img'></img>
						<div><span className='xcx-text'>小程序</span>  魔席网</div>
						<img src='/forest/image/xcx_moxi.jpg' alt="" className='xcx-img'></img>
						{/* <div><span className='xcx-text'>小程序</span>  魔席网</div>
						<img src={require("./gzh.jpg")} alt="" className='qrimg'></img> */}		
					</div>
				</Col>
				<Col span={4}>
					<div className='bottom-banner-itemtext-cn'>联系我们</div>
					<div className='bottom-banner-itemtext-en2'>Contact us</div>
					<div className='bottom-banner-contact'>
						<div className='botton-banner-item'>通过邮箱联系我们</div>
						<Row className='e-mail-body' justify='space-between'>
							<Col className='email-text'>weishi@maigimaigi.cn</Col>
							<Col className='email-img-body'><img className='email-icon' alt="" src='/forest/image/email.png'></img></Col>
						</Row>
						<div className='botton-banner-item'>地址：上海市 长寿路1118号悦达国际大厦</div>
					</div>
				</Col>
				<Col span={22} className="recordtext">Copyright All Rights Reserved 沪ICP备19025351号-1</Col>
			</Row>
		);
        // return(
		// 	<div>
		// 		<Row className="bottom-banner">
		// 			<Row className="bottom-banner-row" justify="center">
		// 				<Col span={4} className="bottom-banner-col"><a className="bottom-banner-a" href="http://www.moxidata.cn/aboutmoxi.php">关于魔席</a></Col>
		// 				<Col span={4} className="bottom-banner-col"><a className="bottom-banner-a">开发商服务</a></Col>
		// 				<Col span={4} className="bottom-banner-col"><a className="bottom-banner-a">运营商服务</a></Col>
		// 				<Col span={4} className="bottom-banner-col"><a className="bottom-banner-a" href="http://www.moxidata.cn/contactus.html">联系我们</a></Col>
		// 			</Row>
					
		// 			<Row className="bottom-banner-rowqr" justify="center">
		// 				<Col span={4} className="qr">
		// 					<div><span style={{color:"#eb962f",marginRight:"5px"}}>小程序</span>魔席网</div>
		// 					<img className="qrimg" alt="" src={require("./moxixcx.jpg")}  />
		// 				</Col>

		// 				<Col span={4} className="qr">
		// 					<div><span style={{color:"#eb962f",marginRight:"5px"}}>小程序</span>True榜样</div>
		// 					<img className="qrimg" alt="" src={require("./truexcx.jpg")} />
		// 				</Col>

		// 				<Col span={4} className="qr">
		// 					<div><span style={{color:"#eb962f",marginRight:"5px"}}>公众号</span>旅游地产观察</div>
		// 					<img className="qrimg" alt="" src={require("./gzh.jpg")} />
		// 				</Col>
		// 			</Row>

		// 			<Row className="bottom-banner-row" justify="center">
		// 				<Col className="bottom-banner-col"><a className="bottom-banner-a" href="http://www.moxidata.cn/systemdashboard.php">返回后台</a></Col>
		// 			</Row>
					
		// 			<Row className="bottom-banner-row" justify="center">
		// 				Copyright All Rights Reserved{'\u00A0'}
		// 				<a className="bottom-banner-a" href="http://www.beian.miit.gov.cn/">沪ICP备19025351号-1</a>
		// 			</Row>
		// 		</Row>
		// 	</div>
        // );
    }
        
}

export default BottomBanner;